




























import { Component, Vue } from 'vue-property-decorator';
import WebstoreApiTokenNew from '@/components/WebstoreApiToken/WebstoreApiTokenNew.vue';

@Component({
  components: {
    WebstoreApiTokenNew,
  },
})
export default class WebstoreApiTokenNewButton extends Vue {
  private showDialog = false;
}
